import React from 'react';
import { Form } from 'react-bootstrap';

const CustomTextArea = ({
  label = '',
  value,
  onChange,
  rows = 4,
  placeholder = '',
  name = '',
  className = '',
  style = {},
  isInvalid = false,
  errorMessage = '',
  ...rest
}) => {
  return (
    <Form.Group className={`${className}`} style={style}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control
        as="textarea"
        className='textarea'
        rows={rows}
        placeholder={placeholder}
        value={value}
        name={name}
        onChange={onChange}
        isInvalid={isInvalid}
        {...rest}
      />
      {isInvalid && (
        <Form.Control.Feedback type="invalid">
          {errorMessage}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default CustomTextArea;
